import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { put, takeEvery } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { putPromise } from '../../helpers/redux'
import {
  EXPORT_TRANSACTIONS_SUCCESS,
  EXPORT_END_OF_MONTH_FLOW_SUCCESS,
  EXPORT_END_OF_MONTH_FLOW_FAILURE,
  APPLY_END_OF_MONTH_FLOW_SUCCESS,
  GET_AVERAGE_LOAN_BALANCE_SUCCESS,
  getLoanBalanceStartDate,
  getLatestEndOfMonthFlow,
  GET_AVERAGE_LOAN_BALANCE_FAILURE,
  EXPORT_TRANSACTIONS_FAILURE,
  EXPORT_INELIGIBLES_SUCCESS,
  EXPORT_INELIGIBLES_FAILURE,
} from './actions'

export function* exportLoanBalanceTransactions() {
  yield takeEvery(EXPORT_TRANSACTIONS_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error: unknown) {
      yield put({ type: EXPORT_TRANSACTIONS_FAILURE, error: error as Error })
    }
  })
}

export function* downloadAverageLoanBalanceResult() {
  yield takeEvery(
    GET_AVERAGE_LOAN_BALANCE_SUCCESS,
    function* (action: IFileDownloadResponse & Action) {
      try {
        yield download(action.data, action.data.name)
      } catch (error: unknown) {
        yield put({ type: GET_AVERAGE_LOAN_BALANCE_FAILURE, error })
      }
    },
  )
}

export function* exportEndOfMonthFlow() {
  yield takeEvery(
    EXPORT_END_OF_MONTH_FLOW_SUCCESS,
    function* (action: IFileDownloadResponse & Action) {
      try {
        yield download(action.data, action.data.name)
      } catch (error: unknown) {
        yield put({ type: EXPORT_END_OF_MONTH_FLOW_FAILURE, error })
      }
    },
  )
}
export function* exportIneligibles() {
  yield takeEvery(EXPORT_INELIGIBLES_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error: unknown) {
      yield put({ type: EXPORT_INELIGIBLES_FAILURE, error: error as Error })
    }
  })
}

export function* reloadLatestEndOfMonthFlow() {
  yield takeEvery(APPLY_END_OF_MONTH_FLOW_SUCCESS, function* () {
    yield putPromise(getLoanBalanceStartDate())
    yield putPromise(getLatestEndOfMonthFlow())
  })
}
